import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Input } from '../models/input';
import { BarraBuscaComponent } from '../shared/barra-busca/barra-busca.component';
import { Observable } from 'rxjs';
import { Breadcrumb } from '../shared/breadcrumb/breadcrumb.model';

@Component({
  selector: 'app-eixo-tecnologico',
  templateUrl: './eixo-tecnologico.component.html',
  styleUrls: ['./eixo-tecnologico.component.scss'],
})
export class EixoTecnologicoComponent implements OnInit {

  @ViewChild(BarraBuscaComponent) barraComponent: BarraBuscaComponent;

  cursos: any;
  eixo: any;
  areasTecnologicas = [];
  deslocamento = 0; // descolamento de página
  paginaAtual: number;
  totalPaginas: number;
  encurtarTexto = true;
  totalResultados = 0;
  eixos: any;
  ordecao: any;
  filtro: any;
  error = false;
  realizouBusca = false;
  componenteRef = 'cursos';
  stringPesquisa: string;
  mostrarCursos = false;
  mostrarAreasTecnologicas = false;
  msgSemArea: string;
  mostrarMsgSemArea = false;
  isCollapsed = false;
  mensagem = '';

  isMobile$: Observable<boolean>;
  breadcrumbItems: Array<Breadcrumb> = [];

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    this.route.data.subscribe((data) => {
      const {
        cursos: { itens, paginaAtual, totalPaginas, totalItens },
        eixos,
        eixo,
        cursoError,
        eixosError,
      } = data;

      this.error = cursoError !== undefined || eixosError !== undefined ? true : false;

      if (!this.error) {
        this.cursos = itens;
        this.paginaAtual = paginaAtual;
        this.totalPaginas = totalPaginas;
        this.totalResultados = totalItens;
        this.eixos = eixos;
        this.eixo = eixo;
        this.mostrarCursos = true;
        this.mostrarAreasTecnologicas = false;
        this.mostrarMsgSemArea = false;
        this.areasTecnologicas = data.areas;
        this.msgSemArea = '';

        if (this.areasTecnologicas.length === 0) {
          this.msgSemArea = 'Este eixo não possui divisão em áreas tecnológicas.';
        }

        if (this.totalResultados) {
          this.mensagem = 'Total de resultados encontrados ' + this.totalResultados;
        }

        if (!this.totalResultados || (!this.totalResultados && this.realizouBusca)) {
          this.mensagem = 'Desculpe, não encontramos nenhum resultado compatível com sua busca.';
        }

        this.breadcrumbItems = [
          { label: 'Página Inicial', url: '/' },
          { label: 'Todos os Cursos', url: '/cursos' },
          { label: this.eixo.nome },
        ];
      }
    });

    this.route.queryParams.subscribe(params => {
      if (!!params.mostrarAreasTecnologicas) {
        this.showAreasTecnologicas();
      }
    });

    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace('#', '');
      setTimeout(() => {
        this.scrollToElement(id);
      }, 1000);
    }
  }

  scrollToElement(elementId: string) {
    const element = document.getElementById(elementId);
    element.scrollIntoView();
    element.classList.add('highlight');
  }

  onPaginaSelecionada(numeroPagina: number) {
    this.paginaAtual = numeroPagina;
    this.router.navigate(['/eixo-tecnologico'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: numeroPagina,
      },
    });
  }

  recebeuInput(input: Input) {
    this.realizouBusca = true;
    this.router.navigate(['/eixo-tecnologico'], {
      queryParamsHandling: 'merge',
      queryParams: {
        pagina: 1,
        query: input.stringBusca,
        areaId: input.areaTecnologica
      },
    }).then(() => {
      // Redefinir o valor de areaTecnologica após a navegação.
      if (this.barraComponent) {
        this.barraComponent.checkArea();
      }
    });
  }

  /**
   *
   */
  showAreasTecnologicas() {
    if (this.msgSemArea === '') {
      this.mostrarCursos = false;
      this.mostrarAreasTecnologicas = true;
    } else {
      this.mostrarMsgSemArea = true;
      this.mostrarCursos = true;
    }
  }

  showCursos(eixo: any, area: any) {
    this.realizouBusca = true;
    this.router.navigate(['/cursos'], {
      queryParamsHandling: 'merge',
      queryParams: {
        eixo: eixo.id,
        areatecnologica: area.id,
        areanome: area.nome
      },
    });
  }

  /**
   *
   * @param dados objeto de entrada.
   */
  showCursosAreas(dados: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/cursos', 'area'], {
        queryParamsHandling: 'merge',
        queryParams: {
          eixoId: dados.eixoId,
          areaId: dados.areaId,
        },
      });
    });
  }

  //
  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
}
